function obterValorAsciiMenos48(caractere: string): number {
  return caractere.charCodeAt(0) - 48;
}

function limparValor(valor?: string): string | undefined {
  if (!valor) return valor;
  return valor.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
}

function verificadorBasico(cnpj?: string): boolean {
  const sequenciasInvalidas = [
    '00000000000000',
    '11111111111111',
    '22222222222222',
    '33333333333333',
    '44444444444444',
    '55555555555555',
    '66666666666666',
    '77777777777777',
    '88888888888888',
    '99999999999999',
  ];

  if (!cnpj) {
    return true;
  }

  if (cnpj.length !== 14) {
    return false;
  }

  const digitosVerificadores = cnpj.slice(12, 14);
  const apenasDigitos = /^\d{2}$/;

  if (!apenasDigitos.test(digitosVerificadores)) {
    return false;
  }

  if (sequenciasInvalidas.some(item => item === cnpj)) {
    return false;
  }

  const todosCaracteresIguais = cnpj.split('').every(c => c === cnpj[0]);
  if (todosCaracteresIguais) {
    return false;
  }

  return true;
}

function verificadorDigito(cnpj: string, pesos: number[]): boolean {
  if (!cnpj || !pesos) {
    return true;
  }

  const caracteres = cnpj.split('').slice(0, pesos.length);
  const soma = caracteres.reduce(
    (acumulador, caractere, indice) =>
      acumulador + obterValorAsciiMenos48(caractere) * pesos[indice],
    0,
  );

  const resto = soma % 11;
  const digito = resto < 2 ? 0 : 11 - resto;
  const digitoInformado = parseInt(cnpj[pesos.length], 10);
  return digitoInformado === digito;
}

function temLetraNosDozePrimeiros(cnpj: string): boolean {
  return /[A-Za-z]/.test(cnpj.slice(0, 12));
}

export function validadorCnpj(valor?: string): boolean {
  if (!valor) {
    return false;
  }

  const cnpj = limparValor(valor);

  if (!cnpj || cnpj.length !== 14) {
    return false;
  }

  const doisUltimos = cnpj.slice(12, 14);
  if (!/^\d{2}$/.test(doisUltimos)) {
    return false;
  }

  if (temLetraNosDozePrimeiros(cnpj)) {
    return true;
  }

  const pesosDigito1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  const pesosDigito2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

  return (
    verificadorBasico(cnpj) &&
    verificadorDigito(cnpj, pesosDigito1) &&
    verificadorDigito(cnpj, pesosDigito2)
  );
}

export function cnpjValidator(value?: string): boolean {
  return validadorCnpj(value);
}
